/** @jsxImportSource @emotion/react */
import React from "react";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../colors";
import { SerializedStyles, css } from "@emotion/react";

interface TableCellHeaderTextProps
  extends React.HTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode;
  className?: string;
  additionalStyling?: SerializedStyles;
}

export const TableCellHeaderText = ({
  children,
  className,
  additionalStyling,
  ...rest
}: TableCellHeaderTextProps) => {
  const cellStyle = css`
    white-space: nowrap;
    vertical-align: middle !important;
    ${additionalStyling}
  `;

  return (
    <th css={cellStyle} className={className}>
      <StyledText
        className={`bodySubtextRegular mb-0`}
        color={colors.textSecondary}
        {...rest}
      >
        {children}
      </StyledText>
    </th>
  );
};
